import styled from 'styled-components';

import { RadiusConfig } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const SelectContainer = styled.div`
  width: 100%;
`;

export const SelectTrigger = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  background: ${COLOR_CONFIG.white};
  margin-bottom: 10px;
`;

export const DropdownMenu = styled.div<{ isOpen: boolean; position: 'top' | 'bottom' }>`
  position: fixed;
  z-index: 4;
  right: 36px;
  width: 100%;
  height: 100%;
  max-width: 432px;
  max-height: 300px;
  overflow-y: auto;
  margin: ${(props) => (props.position === 'top' ? '0 0 16px 0' : '16px 0 0 0')};
  border-radius: ${RadiusConfig.sm}px;
  box-shadow:
    0 0 0 1px hsla(0, 0%, 0%, 0.1),
    0 4px 11px hsla(0, 0%, 0%, 0.1);
  background: hsl(0, 0%, 100%);
  border: 1px solid hsl(0, 0%, 100%);
  display: ${(props) => (props.isOpen ? 'block' : 'none')};

  .es-input-master-wrapper {
    padding: 12px 12px 14px;
  }

  .text-input-wrapper {
    min-width: 100%;
    padding: 12px 16px;
    margin-bottom: 0;
  }
`;

export const OptionItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background-color: ${COLOR.neutral['neutral-4']};
  }
`;

export const OptionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const SelectedList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-left: 30px;
  margin: 0;
  width: 100%;

  > * {
    /* flex: 1 1 calc(50% - 8px);
    max-width: calc(50% - 8px); */
  }
`;

export const SelectedItem = styled.li`
  display: flex;
  align-items: center;
  width: fit-content;
  max-width: 228px;
  gap: 8px;
  cursor: pointer;
  border: 2px solid ${COLOR.primary['primary-3']};
  background: ${COLOR.primary['primary-1']};
  padding: 3px 6px 3px 3px;
  border-radius: ${RadiusConfig.sm}px;
  justify-content: space-between;

  svg path {
    stroke: ${COLOR.primary['primary-6']};
  }
`;

export const AvatarContainer = styled.figure`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  flex: 1;
  overflow: hidden;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
`;
